import { ReactNode } from 'react';
import UltraLightCollection from './UltraLightCollection';
import UltraLightCollectionFeatures from './UltraLightCollectionFeatures';

type TProps = {
  smallPrint?: ReactNode;
};

const MeetTheUltraLightCollection = ({ smallPrint }: TProps) => {
  return (
    <div id='Compare' className='tw-my-5 tw-px-4'>
      <h3 className='tw-mb-6 tw-text-center tw-text-2xl tw-font-bold tw-text-body md:tw-mb-10'>
        MEET THE ULTRA-LIGHT COLLECTION
      </h3>

      <UltraLightCollection />
      <UltraLightCollectionFeatures
        className='md:-tw-mt-[420px] md:tw-pb-16 md:tw-pt-[470px]'
        smallPrint={smallPrint}
      />
    </div>
  );
};

export default MeetTheUltraLightCollection;
